import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ChevronDown, Menu, X, User, LogOut, Bell } from 'lucide-react';

import { useNavigate } from 'react-router-dom';
import NotificationPopup from './NotificationPopup';
import images from '../constants/images';
import '../styles/GlobalStyles.css';

const Navbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isJobsOpen, setJobsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isProfileOpen, setProfileOpen] = useState(false);
  const [isNotificationsOpen, setNotificationsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      fetchNotifications();
    }
  }, [isLoggedIn]);

  const fetchNotifications = async () => {
    try {
      setLoadingNotifications(true);
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/notification/teacher/all`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNotifications(response.data);
    } catch (err) {
      console.error('Error fetching notifications:', err);
    } finally {
      setLoadingNotifications(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/notification/teacher/read/${id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNotifications(prev =>
        prev.map(n => n._id === id ? { ...n, isRead: true } : n)
      );
    } catch (err) {
      console.error("Failed to mark as read", err);
    }
  };

  const unreadCount = notifications.filter(n => !n.isRead).length;

  const categories = ['School', 'Coaching', 'Edtech', 'Pre-School', 'College/University', 'Vocational Training Institute'];
  const locations = [
    "Bangalore", "Hyderabad", "Lucknow", "Coimbatore", "Pune", "Ahmedabad",
    "Delhi", "Patna", "Chennai", "Mumbai", "Indore", "Agra", "Kolkata", "Jaipur", "Bhubaneswar"
  ];

  const designations = [
    'Mathematics Teacher Jobs', 'English Teacher Jobs', 'Teacher Jobs', 'Biology Teacher Jobs',
    'Science Teacher Jobs', 'Hindi Teacher Jobs', 'Social Science Teacher Jobs', 'Physics Teacher Jobs',
    'Chemistry Teacher Jobs', 'Assistant Teacher Jobs', 'Computer Science Teacher Jobs', 'History Teacher Jobs',
    'Computer Teacher Jobs', 'Commerce Teacher Jobs', 'Economics Teacher Jobs', 'Non Teacher Jobs',
    'Academic Coordinator Jobs', 'English Language Teacher Jobs', 'General Teacher Jobs', 'Geography Teacher Jobs',
    'Academic Counsellor Jobs', 'Accountant Jobs', 'Administration Executive Jobs',
    'Physical Education Teacher Jobs', 'Political Science Teacher Jobs'
  ];

  const closeAllDropdowns = () => {
    setJobsOpen(false);
    setOpenDropdown(null);
  };

  const handleNavigate = (city) => {
    navigate(`/jobs/${city.toLowerCase()}`);
  };

  const handleCategoryClick = (text) => {
    const normalized = text.toLowerCase();
    const params = new URLSearchParams();

    if (normalized.includes("pre-school")) params.set("domain", "pre-school");
    else if (normalized.includes("college") || normalized.includes("university")) params.set("domain", "college");
    else if (normalized.includes("edtech")) params.set("domain", "edtech");
    else if (normalized === "school") params.set("domain", "school");
    else return;

    navigate(`/jobs?${params.toString()}`);
  };

  const handleDesignationClick = (text) => {
    const slug = text.toLowerCase().replace(" jobs", "").replace(/\s+/g, "-");
    const params = new URLSearchParams();
    params.set("designation", slug);
    navigate(`/jobs?${params.toString()}`);
  };

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const isTokenValid = () => {
    const token = localStorage.getItem("token");
    if (!token) return false;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.exp ? payload.exp * 1000 > Date.now() : true;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    setIsLoggedIn(isTokenValid());
  }, []);

useEffect(() => {
  const handleClickOutside = (e) => {
    // close profile dropdown
    if (!e.target.closest('.profile-menu')) {
      setProfileOpen(false);
    }

    // close jobs dropdown
    
  };

  document.addEventListener('click', handleClickOutside);
  return () => document.removeEventListener('click', handleClickOutside);
}, []);


  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    navigate('/');
  };

  const getUserName = () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return "Account";
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.name || payload.fullName || "Account";
    } catch {
      return "Account";
    }
  };

  return (
    <>
      {/* ================= DESKTOP NAVBAR ================= */}
       {isJobsOpen && (
  <div
    className="fixed inset-0 z-40"
    onClick={() => {
      setJobsOpen(false);
      setOpenDropdown(null);
    }}
  />
)}
      <header className="hidden md:block absolute top-0 left-0 w-full z-40">

        <nav className="w-full max-w-[1200px] mx-auto px-10 py-5 flex items-center justify-between">


          <img
            src={images.Teachersearch}
            className="h-14 w-auto object-contain cursor-pointer"
            onClick={() => navigate('/')}
            alt="Logo"
          />

          <div className="flex items-center">
            <div className="flex items-center gap-8 px-8 py-3 rounded-full bg-white/40 backdrop-blur-md shadow-sm">
              <button onClick={() => navigate('/')} className="font-medium text-gray-800 hover:text-blue-600">Home</button>

              <div className="relative jobs-dropdown">

                <button onClick={() => setJobsOpen(!isJobsOpen)} className="flex items-center font-medium text-gray-800 hover:text-blue-600">
                  Jobs <ChevronDown className="w-4 h-4 ml-1" />
                </button>
               


                {isJobsOpen && (
                  <div className="absolute top-14 left-1/2 -translate-x-1/2 bg-white shadow-xl rounded-xl p-6 w-[750px] z-50">
                    <div className="flex flex-col gap-4">
                      <DropdownSection label="JOBS BY CATEGORY" items={categories}
                        isOpen={openDropdown === 'category'} toggle={() => toggleDropdown('category')}
                        onItemClick={handleCategoryClick} closeAllDropdowns={closeAllDropdowns} />
                      <DropdownSection label="JOBS BY LOCATIONS" items={locations}
                        isOpen={openDropdown === 'location'} toggle={() => toggleDropdown('location')}
                        onClick={handleNavigate} closeAllDropdowns={closeAllDropdowns} />
                      <DropdownSection label="JOBS BY DESIGNATIONS" items={designations}
                        isOpen={openDropdown === 'designation'} toggle={() => toggleDropdown('designation')}
                        onItemClick={handleDesignationClick} closeAllDropdowns={closeAllDropdowns} />
                    </div>
                  </div>
                )}
              </div>

              {!isLoggedIn && (
                <button onClick={() => navigate('/plans')} className="font-medium text-gray-800 hover:text-blue-600">Plans</button>
              )}

              <button onClick={() => navigate('/about')} className="font-medium text-gray-800 hover:text-blue-600">About Us</button>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {/* Logged in Desktop View */}
            {!isLoggedIn ? (
              <>
                <button
                  onClick={() => navigate("/login")}
                  className="
    w-[100px]
    h-[44px]
    rounded-full
    bg-white
    border
    border-gray-300
    text-black
    text-sm
    font-semibold
    flex
    items-center
    justify-center
    transition-colors
    duration-200
    hover:border-[#2F9EDB]
    hover:text-[#2F9EDB]
  "
                >
                  Login
                </button>


                <button
                  onClick={() => navigate("/user")}
                  className="
    w-[100px]
    h-[44px]
    rounded-full
    bg-[#2F9EDB]        /* DEFAULT (top one) */
    text-white
    text-sm
    font-semibold
    flex
    items-center
    justify-center
    transition-colors
    duration-200
    hover:bg-[#3AB0E8]  /* HOVER (bottom one) */
  "
                >
                  Register
                </button>

              </>
            ) : (

              <>
                <div className="relative">
                  <button
                    onClick={() => {
                      setProfileOpen(false);
                      setJobsOpen(false);
                      setNotificationsOpen(!isNotificationsOpen);
                    }}
                    className={`p-3 rounded-full transition-colors relative ${isNotificationsOpen ? 'bg-blue-50 text-blue-600' : 'hover:bg-white/50 text-gray-700 hover:text-blue-600'}`}
                    title="Notifications"
                  >
                    <Bell className="w-5 h-5" />
                    {unreadCount > 0 && (
                      <span className="absolute top-2 right-2 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white"></span>
                    )}
                  </button>

                  {isNotificationsOpen && (
                    <NotificationPopup
                      onClose={() => setNotificationsOpen(false)}
                      notifications={notifications}
                      markAsRead={markAsRead}
                      loading={loadingNotifications}
                    />
                  )}
                </div>

                <div className="relative profile-menu">
                  <button onClick={() => setProfileOpen(!isProfileOpen)} className="flex items-center px-4 py-2 rounded-full hover:bg-white/50">
                    <User className="w-5 h-5 mr-2" /> {getUserName()}
                  </button>
                  {isProfileOpen && (
                    <div className="absolute right-0 mt-2 w-48 bg-white border rounded-md shadow-lg">
                      <button onClick={() => navigate('/ProfilePage')} className="flex items-center w-full px-4 py-2 hover:bg-gray-100">
                        <User className="mr-2" /> My Profile
                      </button>
                      <button onClick={handleLogout} className="flex items-center w-full px-4 py-2 hover:bg-gray-100">
                        <LogOut className="mr-2" /> Logout
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </nav>
      </header >


      {/* ================= MOBILE NAVBAR ================= */}

     {/* ================= MOBILE NAVBAR ================= */}
<header className="md:hidden fixed top-0 left-0 w-full z-50 bg-white shadow-[0_4px_10px_rgba(0,0,0,0.05)]">
  <div className="h-[76px] px-4 flex items-center justify-between">

    {/* Logo */}
    <img
      src={images.Teachersearch}
      className="h-10 object-contain cursor-pointer"
      onClick={() => navigate('/')}
      alt="Logo"
    />

    {/* Right Section */}
    <div className="flex items-center gap-3">

      {!isLoggedIn ? (
        <>
          {/* Login Button */}
          <button
            onClick={() => navigate('/login')}
            className="
              w-[74px]
              h-[36px]
              rounded-full
              border
              border-gray-300
              bg-white
              text-black
              text-[14px]
              font-medium
              flex items-center justify-center
            "
          >
            Login
          </button>

          {/* Register Button */}
          <button
            onClick={() => navigate('/user')}
            className="
              w-[74px]
              h-[36px]
              rounded-full
              bg-[#2F9EDB]
              text-white
              text-[14px]
              font-medium
              flex items-center justify-center
            "
          >
            Register
          </button>
        </>
      ) : (
        <>
          {/* Notification */}
          <button
            onClick={() => navigate('/notifications')}
            className="w-[40px] h-[40px] flex items-center justify-center"
          >
            <Bell size={20} />
          </button>

          {/* Profile */}
          <button
            onClick={() => navigate('/ProfilePage')}
            className="flex items-center gap-1 text-sm"
          >
            <User size={18} />
          </button>
        </>
      )}

      {/* Menu Button */}
      <button
        onClick={() => setMenuOpen(true)}
        className="w-[40px] h-[40px] flex items-center justify-center"
      >
        <Menu size={22} />
      </button>

    </div>
  </div>
</header>




      {/* ================= MOBILE DRAWER ================= */}
      < div className={`fixed inset-0 z-[999] md:hidden ${isMenuOpen ? "visible" : "invisible"}`}>

        {/* Backdrop */}
        < div
          className="absolute inset-0 bg-black/40"
          onClick={() => setMenuOpen(false)}
        />

        {/* Drawer */}
        <div
          className={`
      absolute top-0 left-0 h-full
      w-[30%] min-w-[240px] max-w-[250px]
      bg-white
      text-gray-800
      shadow-xl
      transition-transform duration-300 ease-out
      ${isMenuOpen ? "translate-x-0" : "-translate-x-full"}
    `}
        >

          {/* Drawer Header */}
          <div className="flex items-center justify-between px-4 py-4 border-b">
            <img
              src={images.Teachersearch}
              className="h-8 object-contain"
              alt="logo"
            />
            <button onClick={() => setMenuOpen(false)}>
              <X size={20} />
            </button>
          </div>

          {/* Drawer Content */}
          <div className="flex flex-col px-4 py-5 text-[15px]">

            {/* Main Links */}
            <button
              onClick={() => { navigate('/'); setMenuOpen(false); }}
              className="flex items-center gap-3 py-2"
            >
              Home
            </button>

            <button
              onClick={() => { navigate('/jobs'); setMenuOpen(false); }}
              className="flex items-center gap-3 py-2"
            >
              Find Jobs
            </button>

            <button
              onClick={() => { navigate('/about'); setMenuOpen(false); }}
              className="flex items-center gap-3 py-2"
            >
              About Us
            </button>

            {/* Divider */}
            <div className="my-4 border-t" />

            {/* Logged In Section */}
            {isLoggedIn && (
              <>
                <button
                  onClick={() => { navigate('/ProfilePage'); setMenuOpen(false); }}
                  className="flex items-center gap-3 py-2"
                >
                  <User size={16} />
                  <span>My Profile</span>
                </button>

                <button
                  onClick={() => {
                    handleLogout();
                    setMenuOpen(false);
                  }}
                  className="flex items-center gap-3 py-2 mt-2 text-red-600"
                >
                  <LogOut size={16} />
                  <span>Logout</span>
                </button>
              </>
            )}



          </div>
        </div>
      </div >


    </>
  );
};

const DropdownSection = ({ label, items, isOpen, toggle, onClick, onItemClick, closeAllDropdowns }) => (
  <div className="w-full">
    <button onClick={toggle} className="flex justify-between w-full text-sm font-semibold text-blue-600 uppercase">
      {label}
      <ChevronDown className={`w-4 h-4 transition ${isOpen ? "rotate-180" : ""}`} />
    </button>
    {isOpen && (
      <div className="grid grid-cols-3 gap-4 mt-4">
        {items.map((item, idx) => (
          <button key={idx} onClick={() => {
            if (onClick) onClick(item.toLowerCase());
            if (onItemClick) onItemClick(item);
            closeAllDropdowns();
          }} className="text-xs text-gray-600 text-left hover:text-blue-600 hover:underline">
            {item}
          </button>
        ))}
      </div>
    )}
  </div>
);

export default Navbar;
